module.exports = __webpack_public_path__ + "img/gzh.dd48b2e7.jpg";